module.exports = __webpack_public_path__ + "img/2.bfb07959.png";